import { Observable } from "rxjs/Observable";
import { ApiRequestOptions } from "../../../core/services/api/request-options";
import { CategoryApiFacade } from "../category/category.api-facade";
import { TaskType } from "./task-type.model";

export class TaskTypeApiFacade extends CategoryApiFacade<TaskType> {

    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<TaskType> {
        return this.GET(`/accounts/${accountId}/tasktypes/${id}`, options)
            .map(object => new TaskType(object));
    }

    getAll(accountId: string, options?: ApiRequestOptions): Observable<Array<TaskType>> {
        return this.CGET(`/accounts/${accountId}/tasktypes`, options)
            .map(objects => objects.map(object => new TaskType(object)));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/task-type/task-type.api-facade.ts